import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const EuropePage = () => {
  return <DestinationTemplate destinationId="europe" />;
};

export default EuropePage;
